import type { CodeWidgetData } from '@web/widgets/code/type';

import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { filter, takeUntil } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';

import { ESelectedEntityType } from '@common/types/layout.type';

import { WebBaseViewComponent } from '@web/widgets/common/abstract/web-base-view.component';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';

import LayoutActions from '@web/store/layout/layout.actions';

import { CodeModalComponent } from './code-modal/code-modal.component';
import { getStyles } from './code-view.component.styles';

@Component({
    selector: 'web-code-view',
    templateUrl: './code-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule],
})
export class CodeViewComponent extends WebBaseViewComponent<CodeWidgetData> implements OnInit {
    private readonly modalService: BsModalService = inject(BsModalService);
    private readonly actions$: Actions = inject(Actions);

    protected getStyles = getStyles;

    public ngOnInit() {
        super.ngOnInit();

        this.actions$
            .pipe(
                ofType(LayoutActions.setSelectedEntity),
                takeUntil(this.unsubscribe$),
                filter(({ selectedEntity }) => selectedEntity?.entityId === this.widgetId)
            )
            .subscribe(() => {
                this.openModal();
            });
    }

    public onChangeContent(content: string): void {
        this.widgetsFacade.updateLegacyWidgetProperties(this.widget.id, { data: { content } });
    }

    public selectEntity(): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.widget, entityId: this.widgetId });
    }

    public openModal(): void {
        const modal = this.modalService.show(CodeModalComponent, {
            class: 'modal-lg',
            initialState: { content: this.content },
        });

        modal.content.onClose.subscribe((content: string) => {
            if (content !== null) {
                this.onChangeContent(content);
            }
        });
    }

    public get widgetId(): string {
        return this.widget.id;
    }

    public get content(): string {
        return this.widgetData.content;
    }
}
